import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PocketbaseService } from './services/pocketbase.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const pocketbaseService = inject(PocketbaseService);
  const router = inject(Router);

  if(pocketbaseService.loggedIn()){
    return true;
  }

  // return router.parseUrl('/login');
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url }
  });
};
